import { render, staticRenderFns } from "./static-field.vue?vue&type=template&id=0c2dc73a&scoped=true&"
import script from "./static-field.vue?vue&type=script&lang=js&"
export * from "./static-field.vue?vue&type=script&lang=js&"
import style0 from "./static-field.vue?vue&type=style&index=0&id=0c2dc73a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2dc73a",
  null
  
)

export default component.exports